import React, { useState, useEffect } from 'react';
import { Button, TextField, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { tokenManager } from '../api/apiutils';

const LoginForm = () => {
  const [code, setCode] = useState('');
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const savedUserName = localStorage.getItem('saved_userName');
    if (savedUserName) {
      setUserName(savedUserName);
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new URLSearchParams();
    formData.append('userName', userName);
    formData.append('code', code);

    try {
      const response = await fetch('/api/users/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error sending code:', errorText);
        throw new Error(`HTTP error! Status: ${response.status}, Details: ${errorText}`);
      }

      const data = await response.json();
      tokenManager.setTokens(data.token, data.refreshToken);

      navigate('/active-users');
    } catch (error) {
      console.error('Failed to login:', error);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: { xs: 6, sm: 12 } }}>
      <Typography variant="h5" gutterBottom>
        Вход
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Код"
          variant="outlined"
          type="text"
          fullWidth
          margin="normal"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
        >
          Войти
        </Button>
      </form>
    </Container>
  );
};

export default LoginForm;
